<template>
  <div v-if="properties.length" class="mt-5">
    <h4 class="mb-4">🏘 {{ $t('residential_complex.complex.properties_in_complex') }}</h4>
    <div class="row">
      <div
        class="col-md-6 col-lg-4 mb-4"
        v-for="property in properties"
        :key="property.id"
      >
        <div class="card h-100 shadow-sm">
          <img
            v-if="property.cover_image_url"
            :src="property.cover_image_url"
            class="card-img-top"
            style="height: 200px; object-fit: cover;"
          />
          <div class="card-body">
            <h5 class="card-title">{{ property.title }}</h5>
            <p class="card-text">
              {{ property.rooms || '—' }} | {{ property.gross_area }} {{ $t('common.sqm') }}<br />
              {{ property.city }}, {{ property.district }}<br />
              <strong>€ {{ Number(property.price).toLocaleString() }}</strong>
            </p>
            <a
              :href="`/public/properties/${property.id}`"
              class="btn btn-outline-primary btn-sm"
            >
              {{ $t('residential_complex.complex.description') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  residentialComplexId: Number
})

const properties = ref([])

const fetchProperties = async () => {
  if (!props.residentialComplexId) return

  try {
    const res = await fetch(`/api/v1/residential_complexes/${props.residentialComplexId}/properties`)
    properties.value = await res.json()
  } catch (err) {
    console.error('Ошибка загрузки квартир:', err)
  }
}

watch(() => props.residentialComplexId, fetchProperties, { immediate: true })
</script>
